var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 122.67 106.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#384e6d;}.cls-4{fill:#168241;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-86.52 -142.55)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.49,
    y: 108.23,
    width: 174.73,
    height: 174.73
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 100.43,
    y: 18.78,
    width: 1.11,
    height: 26.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 93.22,
    y: 10.34,
    width: 1.11,
    height: 34.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.01,
    y: 10.34,
    width: 1.11,
    height: 34.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.8,
    y: 4.44,
    width: 1.11,
    height: 40.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 71.59,
    y: 4.44,
    width: 1.11,
    height: 40.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 64.38,
    y: 4.44,
    width: 1.11,
    height: 40.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 57.17,
    y: 4.44,
    width: 1.11,
    height: 40.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 49.96,
    y: 4.44,
    width: 1.11,
    height: 40.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.75,
    y: 4.44,
    width: 1.11,
    height: 40.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 35.54,
    y: 9.46,
    width: 1.11,
    height: 35.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.33,
    y: 17.02,
    width: 1.11,
    height: 28.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.12,
    y: 17.02,
    width: 1.11,
    height: 28.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.71,183.17h-.12a61.31,61.31,0,0,0-105.51-17.71l0,0a61.36,61.36,0,0,0-9.92,17.66,59,59,0,0,0-2.48,8.89h0a61,61,0,0,0-1.11,10.09,2.44,2.44,0,0,0,0,.27c0,.49,0,1,0,1.46H95.4a51.73,51.73,0,0,1,1.35-11.82h1.73a15.91,15.91,0,0,1,22.07,0,15,15,0,0,1,1.75,1.86,14.58,14.58,0,0,1,1.74-1.86,15.93,15.93,0,0,1,22.09,0,14.17,14.17,0,0,1,1.73,1.86,13.44,13.44,0,0,1,1.73-1.86,15.92,15.92,0,0,1,22.08,0,15.9,15.9,0,0,1,1.75,1.86,13.81,13.81,0,0,1,1.74-1.86,15.91,15.91,0,0,1,22.07,0H199a51.73,51.73,0,0,1,1.35,11.82h8.88A75.91,75.91,0,0,0,205.71,183.17Zm-17.65-4c-.36-.05-.73-.08-1.11-.1l-.75,0a15.41,15.41,0,0,0-5.34.94c-.39.14-.76.29-1.12.45a17.33,17.33,0,0,0-4.19,2.69,17,17,0,0,0-1.9,1.92l-.23.29c-.12-.14-.41-.51-.88-1s-.75-.76-1.26-1.21a17.27,17.27,0,0,0-4.85-3c-.35-.15-.72-.28-1.1-.4a15.74,15.74,0,0,0-4.72-.72q-.71,0-1.38.06c-.38,0-.75.08-1.11.14a16.15,16.15,0,0,0-6.1,2.36c-.4.25-.77.51-1.11.77s-.65.51-.94.75a15.6,15.6,0,0,0-2.11,2.21,16.65,16.65,0,0,0-2.12-2.21c-.28-.24-.6-.5-.93-.75s-.71-.52-1.11-.77a16.21,16.21,0,0,0-6.1-2.36c-.36-.06-.73-.1-1.11-.14s-.91-.06-1.39-.06a15.62,15.62,0,0,0-4.71.72,11.11,11.11,0,0,0-1.11.4,17.42,17.42,0,0,0-4.85,3c-.5.45-.92.86-1.25,1.21s-.77.86-.88,1l-.23-.29a18.92,18.92,0,0,0-1.9-1.92,17.41,17.41,0,0,0-4.2-2.69q-.54-.24-1.11-.45a15.51,15.51,0,0,0-5.35-.94l-.75,0c-.38,0-.75,0-1.11.1a16.14,16.14,0,0,0-7.57,3,52.42,52.42,0,0,1,7.57-12c.36-.43.73-.86,1.11-1.28a51.55,51.55,0,0,1,6.1-5.81c.36-.3.73-.59,1.11-.88a52,52,0,0,1,6.1-4c.37-.21.73-.42,1.11-.61a50.89,50.89,0,0,1,6.1-2.78l1.11-.41a52,52,0,0,1,6.1-1.75l1.11-.23a50.88,50.88,0,0,1,6.1-.85l1.11-.07c1-.06,2-.09,3.05-.09s2,0,3,.09l1.11.07a51.45,51.45,0,0,1,6.1.85l1.11.23a52,52,0,0,1,6.1,1.75l1.1.41a51,51,0,0,1,6.11,2.78c.37.19.74.4,1.11.61a51.83,51.83,0,0,1,6.09,4l1.12.88A53.09,53.09,0,0,1,187,169c.38.42.75.85,1.11,1.28a52.42,52.42,0,0,1,7.57,12A16.14,16.14,0,0,0,188.06,179.21Z",
    transform: "translate(-86.52 -142.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.74,231.36h-6l.14-17.37h5.83Z",
    transform: "translate(-86.52 -142.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.06,199.24v35a13.64,13.64,0,0,1-7.7,12.63,16.42,16.42,0,0,1-7.43,1.77,15.38,15.38,0,0,1-2.87-.24H133a16.09,16.09,0,0,1-4.53-1.55,15.11,15.11,0,0,1-5.62-5,13.85,13.85,0,0,1-2-6c0-.32,0-.63-.06-1h6a7.52,7.52,0,0,0,2.72,5.56,9.32,9.32,0,0,0,4.45,2.1,9.6,9.6,0,0,0,2,.18,9.75,9.75,0,0,0,6.56-2.28,7.33,7.33,0,0,0,1.91-2.38,8.55,8.55,0,0,0,.84-3.85v-35Z",
    transform: "translate(-86.52 -142.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.54,202.42a2.44,2.44,0,0,1,0-.27,59.12,59.12,0,0,1,1.09-10.09",
    transform: "translate(-86.52 -142.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.12,183.17A66,66,0,0,1,100,165.51l0,0",
    transform: "translate(-86.52 -142.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.71,183.17a39.13,39.13,0,0,0-3.26-7.22",
    transform: "translate(-86.52 -142.55)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.6c85f30c3714ae48d63cf41dcac0cafb.svg";
export { ForwardRef as ReactComponent };